import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppPaginatorIntl } from './Shared/_services/app-paginator-intl';
import { ApplicationConfig } from '@angular/core';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { ReloadOnParamChangeStrategy } from './Shared/_services/reload-on-param-change.strategy';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthInterceptor } from './Shared/_interceptors/auth-interceptor.service';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // No provideClientHydration(): the back office is served as a plain
    // browser app (no server rendering), so there is never anything to
    // hydrate - it only logged NG0505 on every page.
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    // Paginator wording for every list ("Rows per page", "1–10 of 54").
    { provide: MatPaginatorIntl, useClass: AppPaginatorIntl },
    // Edit pages flagged reloadOnParamChange start fresh on Previous / Next.
    { provide: RouteReuseStrategy, useClass: ReloadOnParamChangeStrategy },
    // ng2-charts 10: chart.js parts used by the dashboard (was NgChartsModule).
    provideCharts(withDefaultRegisterables()),
  ],
};
